export default "#define SHADER_NAME column-layer-fragment-shader\n\nprecision highp float;\n\nvarying vec4 vColor;\n\nvoid main(void) {\n  gl_FragColor = vColor;\n  DECKGL_FILTER_COLOR(gl_FragColor, geometry);\n}\n";
//# sourceMappingURL=column-layer-fragment.glsl.js.map


// WEBPACK FOOTER //
// ./~/@deck.gl/layers/dist/esm/column-layer/column-layer-fragment.glsl.js